import { render, staticRenderFns } from "./Kurikulum.vue?vue&type=template&id=e8b3ff86&scoped=true"
import script from "./Kurikulum.vue?vue&type=script&lang=js"
export * from "./Kurikulum.vue?vue&type=script&lang=js"
import style0 from "./Kurikulum.vue?vue&type=style&index=0&id=e8b3ff86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b3ff86",
  null
  
)

export default component.exports